import { gql } from '@apollo/client';

export const GET_FINAL_APPROVAL_BLOCKING_ERRORS = gql`
  query GetFinalApprovalBlockingErrors($trackId: IdentifierType!) {
    finalApprovalBlockingErrors(trackId: $trackId)
  }
`;
